import { render, staticRenderFns } from "./ConsultOpenedByOtherWarning.vue?vue&type=template&id=547eb0c4&"
import script from "./ConsultOpenedByOtherWarning.vue?vue&type=script&lang=js&"
export * from "./ConsultOpenedByOtherWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports